// extracted by mini-css-extract-plugin
export default {"toggleItemSelected":"ToggleItem_toggleItemSelected__Gg+2W","text":"ToggleItem_text__wEXeR","toggleItemUnselected":"ToggleItem_toggleItemUnselected__j2mWk"};